import Swal from 'sweetalert2';

// Images
import IconCorrect from 'Assets/images/icons/correct.png';
import IconPlay from 'Assets/images/icons/play.png';
import IconPause from 'Assets/images/icons/pause.png';
import IconStop from 'Assets/images/icons/stop.png';
import IconFailedPayment from 'Assets/images/icons/fail-payment.png';
import IconVictory from 'Assets/images/icons/victory.png';

const customStyle = {
  customClass: {
    title: 'color-white',
    confirmButton: 'btn btn-primary mx-2',
    cancelButton: 'btn btn-secondary mx-2',
    htmlContainer: 'color-white fs-14 mx-0 swal-strategy',
  },
  buttonsStyling: false,
  padding: '3em',
};

const swalWithBootstrapButtons = Swal.mixin(customStyle);

export default (title) =>
  swalWithBootstrapButtons
    .fire({
      title,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      background: '#1c2b4c',
      imageUrl: IconCorrect,
    })
    .then((result) => {
      return result;
    });

export const Information = (title) =>
  swalWithBootstrapButtons
    .fire({
      title,
      confirmButtonText: 'OKAY',
      background: '#1c2b4c',
      imageUrl: IconCorrect,
    })
    .then((result) => {
      return result;
    });

export const ErrorMessage = (title) =>
  swalWithBootstrapButtons
    .fire({
      icon: 'error',
      title,
      confirmButtonText: 'OKAY',
      background: '#1c2b4c',
    })
    .then((result) => {
      return result;
    });

// Strategy
export const StartStrategy = (title, price, strategyName = '') =>
  swalWithBootstrapButtons
    .fire({
      title: `<h5>${title}</h5>`,
      html: `<img src="${IconPlay}"/><br/><h5>Confirm integration into your portfolio</h5>
      <div>${strategyName} will automate trades on your behalf, using ${price || 3} (% of cash balance, hard $ value) 
      You can pause or stop this strategy at any time</div>`,
      confirmButtonText: title,
      showCancelButton: true,
      background: '#1c2b4c',
      customClass: {
        ...customStyle.customClass,
        title: 'color-white pt-0',
      },
    })
    .then((result) => {
      return result;
    });

export const PauseStrategy = (title) =>
  swalWithBootstrapButtons
    .fire({
      title: `Pause Strategy`,
      html: `<img src="${IconPause}"/><br/>This will pause your portfolio automatically following the <br/> trades of ${title} <br/>
      (your subscription will remain active)`,
      confirmButtonText: 'Pause Strategy',
      showCancelButton: true,
      background: '#1c2b4c',
      customClass: {
        ...customStyle.customClass,
        title: 'color-white pt-0',
      },
    })
    .then((result) => {
      return result;
    });

export const StopStrategy = (title) =>
  swalWithBootstrapButtons
    .fire({
      title: `Stop Strategy`,
      html: `<img src="${IconStop}"/><br/>This will cancel your subscription to ${title}
      and no further trades placed by this strategy will be automated`,
      confirmButtonText: 'Stop Strategy',
      showCancelButton: true,
      background: '#1c2b4c',
      customClass: {
        ...customStyle.customClass,
        title: 'color-white pt-0',
      },
    })
    .then((result) => {
      return result;
    });

export const FailedPayment = () =>
  swalWithBootstrapButtons
    .fire({
      title: `Payment Failed`,
      html: `<img src="${IconFailedPayment}" class="strategy-failed-payment "/><br/>Your order could not be completed at this time.
      Please try again soon.<br/><br/><p>We’ll be waiting right here for you!</p>`,
      confirmButtonText: 'Continue',
      background: '#1c2b4c',
    })
    .then((result) => {
      return result;
    });

export const VictoryPayment = (title, brokerName) =>
  swalWithBootstrapButtons
    .fire({
      title: `Victory!`,
      html: `<img src="${IconVictory}" class="strategy-success-payment"/><br/>Payment Successful<br/><br/>
        <p>Investing just became easier! ${title} will begin placing orders in your ${brokerName} account. </p>
        <br/>You can pause or cancel this strategy at any time by clicking on your portfolio in the profile page and heading to ‘Active Strategies.’`,
      confirmButtonText: 'Continue',
      background: '#1c2b4c',
    })
    .then((result) => {
      return result;
    });

export const HostRequirements = (requirements) =>
  swalWithBootstrapButtons
    .fire({
      title: `Requirements`,
      html: requirements,
      confirmButtonText: 'Proceeed',
      background: '#1c2b4c',
      customClass: {
        ...customStyle.customClass,
        htmlContainer: 'color-white fs-14 mx-0 swal-host-requirements',
        title: 'color-white pt-0 mb-3',
      },
    })
    .then((result) => {
      return result;
    });

export const BotRejected = () =>
  swalWithBootstrapButtons
    .fire({
      title: `Bot Rejected`,
      html: `<img src="${IconFailedPayment}" class="strategy-failed-payment "/><br/>
      Your bot didn’t meet the requirements to list on the marketplace<br/><br/><p>Please revise and try again!</p>`,
      confirmButtonText: 'Ok',
      background: '#1c2b4c',
    })
    .then((result) => {
      return result;
    });

export const MisplacedBroker = () =>
  swalWithBootstrapButtons
    .fire({
      title: ``,
      html: `<img src="${IconFailedPayment}" class="strategy-failed-payment "/><br/> Coming soon`,
      confirmButtonText: 'Continue',
      background: '#1c2b4c',
    })
    .then((result) => {
      return result;
    });
